import React from 'react';
import './EventTimeline.css';

interface EventTimelineProps {
  eventName: string;
  eventDate: string;
  timeline: {
    invitationCloseDate: string;
    invitationCloseTime: string;
    mealAssignmentDate: string;
    mealAssignmentTime: string;
    firstMessageTime: string;
    starterTime: string;
    mainCourseMessageTime: string;
    mainCourseTime: string;
    dessertMessageTime: string;
    dessertTime: string;
    finalPartyTime: string;
  };
}

const EventTimeline: React.FC<EventTimelineProps> = ({ eventName, eventDate, timeline }) => {
  const eventDateObj = new Date(eventDate);
  const eventDateFormatted = eventDateObj.toLocaleDateString('nb-NO', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="event-timeline">

      <div className="timeline-section before-event">
        <h4>Før arrangementet</h4>
        <div className="timeline-items">
          <div className="timeline-item">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                {timeline.invitationCloseDate} kl. {timeline.invitationCloseTime}
              </div>
              <div className="timeline-title">Påmelding stenger</div>
              <div className="timeline-description">
                Siste frist for å melde seg på arrangementet
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                {timeline.mealAssignmentDate} kl. {timeline.mealAssignmentTime}
              </div>
              <div className="timeline-title">Matlaging tildeles</div>
              <div className="timeline-description">
                Du får beskjed om hvilken rett du skal lage (forrett, hovedrett eller dessert).
                Tips: Forbered så mye som mulig på forhånd for å holde ting smooth!
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="timeline-section event-day">
        <h4>På arrangementsdagen, {eventDateFormatted}</h4>
        <div className="timeline-items">
          <div className="timeline-item">
            <div className="timeline-marker message"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                Kl. {timeline.firstMessageTime}
              </div>
              <div className="timeline-title">Første melding sendes ut</div>
              <div className="timeline-description">
                Du får beskjed om hvor forretten skal serveres
              </div>
            </div>
          </div>

          <div className="timeline-item meal-stop">
            <div className="timeline-marker starter"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                Kl. {timeline.starterTime}
              </div>
              <div className="timeline-title">🍽️ Forrett serveres</div>
              <div className="timeline-description">
                Arrangementet starter! Møt opp glad, nyt forretten og bli kjent med dine nye venner
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-marker message"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                Kl. {timeline.mainCourseMessageTime}
              </div>
              <div className="timeline-title">Melding om hovedrett</div>
              <div className="timeline-description">
                Du får beskjed om hvor hovedretten serveres. Gjør deg klar for en sykkeltur!
              </div>
            </div>
          </div>

          <div className="timeline-item meal-stop">
            <div className="timeline-marker main"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                Kl. {timeline.mainCourseTime}
              </div>
              <div className="timeline-title">🍝 Hovedrett serveres</div>
              <div className="timeline-description">
                Sykkle til neste stopp og nyt en deilig hovedrett sammen med flere nye venner
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-marker message"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                Kl. {timeline.dessertMessageTime}
              </div>
              <div className="timeline-title">Melding om dessert</div>
              <div className="timeline-description">
                Du får beskjed om hvor desserten serveres - på med sykkelhjelmen igjen!
              </div>
            </div>
          </div>

          <div className="timeline-item meal-stop">
            <div className="timeline-marker dessert"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                Kl. {timeline.dessertTime}
              </div>
              <div className="timeline-title">🍰 Dessert serveres</div>
              <div className="timeline-description">
                Møt enda flere venner til en søt avslutning før festen fortsetter
              </div>
            </div>
          </div>

          <div className="timeline-item party">
            <div className="timeline-marker final"></div>
            <div className="timeline-content">
              <div className="timeline-time">
                Kl. {timeline.finalPartyTime}
              </div>
              <div className="timeline-title">🎉 Fest på sluttdestinasjonen!</div>
              <div className="timeline-description">
                Alle samles for en hyggelig avslutning sammen - del historier fra kvelden og kos dere videre, natten lang!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventTimeline;
